// extracted by mini-css-extract-plugin
export var box = "_4y-0";
export var check = "_4y-1";
export var checkboxButton = "_4y-6";
export var checkboxGroup = "_4y-5";
export var disabled = "_4y-7";
export var ghost = "_4y-9";
export var input = "_4y-2";
export var label = "_4y-4";
export var normal = "_4y-8";
export var uncheck = "_4y-3";